import React from 'react';
import Header from '../components/header/Header'
import Footer from '../components/footer/Footer'
import dataFaq from '../assets/fake-data/data-faq';
import dataTechnology from '../assets/fake-data/data-technology';
import img from '../assets/images/items/group-ntf-01.png'
import Action from '../components/layouts/Action';
import FAQ2 from '../components/layouts/FAQ2';
import Technology from '../components/layouts/Technology';

const FAQ = () => {
    return (
        <div className='web'>
            <Header />
            <section className="tf-section page-title">
                <div className="container">
                    <div className="col-md-12">
                        <div className="page-title__body web">
                            <div className="block-text pt-12">
                                <h2 className="sub-title mb-20">I make websites</h2>
                                <p className="fs-24 mb-33" >Wed development for everyone <br /> Want to make something new or a just simple update? </p>
                            </div>
                            <img src={img} alt="Custom web development React UI/UX design Web3 blockchain solutions Ethereum Cardano" />
                        </div>
                    </div>
                </div>
            </section>
            <Technology data={dataTechnology} />
             <FAQ2 data={dataFaq} />
            <Action />
            <Footer />
        </div>
    );
}

export default FAQ;